module.exports = __webpack_public_path__ + "img/215.da3c30c6.png";